import React, { useState, useRef, useEffect } from 'react';
import {
  LayoutDashboard, ClipboardList, Building2, Package,
  Megaphone, ShoppingCart, Truck, ClipboardCheck, Coins, Receipt,
  CreditCard, Users, Check, RefreshCw, ChevronUp, ChevronRight,
  Shield, UserCog, Bell, ScrollText
} from 'lucide-react';
import { ROLE_PERMISSIONS, AVAILABLE_ROLES } from '../data/mockData';

const Sidebar = ({ activeTab, setActiveTab, currentRole, onRoleChange, deliveryWaitingCount = 0 }) => {
  const [isRoleMenuOpen, setIsRoleMenuOpen] = useState(false);
  const roleMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (roleMenuRef.current && !roleMenuRef.current.contains(event.target)) {
        setIsRoleMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const allMenuItems = [
    { id: 'dashboard', label: '工作台', icon: LayoutDashboard },
    { id: 'approval', label: '审批管理', icon: ClipboardList },
    { id: 'base', label: '基地管理', icon: Building2 },
    { id: 'materials', label: '基地物料', icon: Package },
    { id: 'demand', label: '采购需求', icon: Megaphone },
    { id: 'order', label: '订单管理', icon: ShoppingCart },
    { id: 'delivery', label: '送货单管理', icon: Truck },
    { id: 'arrival_notice', label: '预到货通知', icon: Bell },
    { id: 'stockin_manage', label: '入库单管理', icon: ClipboardCheck },
    { id: 'settlement_manage', label: '结算单管理', icon: Coins },
    { id: 'invoice_manage', label: '发票单管理', icon: Receipt },
    { id: 'payment', label: '付款单管理', icon: CreditCard },
    { id: 'users', label: '客商管理', icon: Users },
    { id: 'sub_account', label: '子账号管理', icon: UserCog },
    { id: 'role_permission', label: '岗位权限', icon: Shield },
    { id: 'operation_log', label: '税务查证', icon: ScrollText },
  ];

  const visibleMenuItems = allMenuItems.filter(item => 
    ROLE_PERMISSIONS[currentRole]?.includes(item.id)
  );

  return (
    <div className="w-64 bg-slate-900 text-slate-300 flex flex-col h-screen fixed left-0 top-0 z-10 shadow-xl">
      <div className="p-6 flex items-center gap-3 border-b border-slate-700">
        <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center text-white font-bold">C</div>
        <span className="text-lg font-bold text-white tracking-wide">废钢直通车</span>
      </div>
      <nav className="flex-1 overflow-y-auto py-6">
        {visibleMenuItems.map((item) => {
          const isDelivery = item.id === 'delivery';
          const showBadge = isDelivery && deliveryWaitingCount > 0;

          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-6 py-3 text-sm font-medium transition-colors border-l-4 ${
                activeTab === item.id
                  ? 'bg-slate-800 text-white border-blue-500'
                  : 'border-transparent hover:bg-slate-800 hover:text-white'
              }`}
            >
              <item.icon size={18} />
              <span className="flex-1 text-left">{item.label}</span>
              {showBadge && (
                <span className="bg-amber-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold animate-pulse">
                  {deliveryWaitingCount}
                </span>
              )}
            </button>
          );
        })}
      </nav>
      
      <div className="p-4 border-t border-slate-800 relative">
        <div className="relative" ref={roleMenuRef}>
            {isRoleMenuOpen && (
                <div className="absolute bottom-full left-0 w-full mb-2 bg-white rounded-lg shadow-xl overflow-hidden border border-slate-200 py-1 z-20">
                    {AVAILABLE_ROLES.map(role => (
                        <button 
                            key={role.id}
                            onClick={() => { onRoleChange(role.id); setIsRoleMenuOpen(false); }}
                            className={`w-full text-left px-4 py-2 text-xs flex items-center justify-between ${currentRole === role.id ? 'bg-blue-50 text-blue-600 font-medium' : 'text-slate-600 hover:bg-slate-50'}`}
                        >
                            {role.label}
                            {currentRole === role.id && <Check size={14}/>}
                        </button>
                    ))}
                </div>
            )}
            
            <button 
                onClick={() => setIsRoleMenuOpen(!isRoleMenuOpen)}
                className="flex items-center gap-2 w-full p-2 mb-3 rounded-lg bg-slate-800 hover:bg-slate-700 text-xs text-slate-300 transition-colors"
            >
                <RefreshCw size={14} className="text-blue-400"/>
                <span>当前岗位: {AVAILABLE_ROLES.find(r => r.id === currentRole)?.label}</span>
                <ChevronUp size={14} className="ml-auto"/>
            </button>
        </div>

        <button 
          onClick={() => setActiveTab('user_center')}
          className={`flex items-center gap-3 w-full p-2 rounded-lg transition-colors text-left ${
            activeTab === 'user_center' ? 'bg-slate-800' : 'hover:bg-slate-800'
          }`}
        >
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-sm font-bold text-white shadow-lg">赵</div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">赵旭东</p>
            <p className="text-xs text-slate-400 flex items-center gap-1 truncate">
               个人中心 <ChevronRight size={10} />
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
